import React, { useEffect, useState } from 'react';
import GoogleReviews from '../components/GoogleReviews';
import fleetImage from '../assets/images/jetblack-bg.png';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

// Importa las imágenes de servicios
import sprinterService from '../assets/images/sprinter_service.png';
import escaladeService from '../assets/images/escalade_service.png';
import lincolnTransfer from '../assets/images/lincoln_transfer.png';

const servicesData = [
  {
    image: sprinterService,
    title: 'Airport Transfer',
    subtitle: 'Services',
    description:
      'Reliable, timely, and comfortable transfers to and from major airports, ensuring a stress-free travel experience.',
  },
  {
    image: escaladeService,
    title: 'Corporate Events Transportation',
    description:
      'Reliable and punctual service tailored for business meetings, conferences, and corporate gatherings.',
  },
  {
    image: lincolnTransfer,
    title: 'Point to Point Transfer Service',
    description:
      'Enjoy seamless, timely transfers between locations with our comfortable point-to-point service.',
  },
];

export default function MobileHome() {
  const [showServices, setShowServices] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowServices(true);
        }
      },
      { threshold: 0.3 }
    );
    const section = document.querySelector('#servicesSection');
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div style={styles.pageContainer}>
      <main style={styles.contentContainer}>
        {/* Sección de imagen que abarca todo el ancho */}
        <section style={styles.heroImageSection}>
          <img src={fleetImage} alt="Luxury Vehicles Fleet" style={styles.heroImage} />
        </section>

        {/* Sección de texto debajo de la imagen */}
        <section style={styles.heroTextSection}>
          <h2 style={styles.subtitle}>OUR COMPANY</h2>
          <h1 style={styles.title}>
            We Provide Luxury <span style={styles.boldText}>Limousine and Car Service</span>
          </h1>
          <p style={styles.subDescription}>
            in Westchester County, Dutchess County, Putnam County, Orange County, Fairfield County.
          </p>
        </section>

        {/* Botones debajo del texto */}
        <div style={styles.buttonContainer}>
          <button
            style={styles.button}
            onClick={() => (window.location.href = '/reservations')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
            }}
          >
            <FaEnvelope style={styles.icon} />
            Book Now or Custom Quote!
          </button>

          <button
            style={styles.button}
            onClick={() => (window.location.href = 'tel:+19149628444')}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
            }}
          >
            <FaPhoneAlt style={styles.icon} />
            Call Now: +1 (914) 962-8444
          </button>
        </div>

        {/* Sección de Servicios */}
        <section
          id="servicesSection"
          style={{
            ...styles.servicesSection,
            opacity: showServices ? 1 : 0,
            transform: showServices ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.8s ease, transform 0.8s ease',
          }}
        >
          <h4 style={styles.sectionTitle}>
            <span style={styles.ourText}>OUR</span> <span style={styles.ourText}>SERVICES</span>
          </h4>
          <h1 style={styles.mainHeading}>
            We Provide Luxury Limousine and Car Service in Westchester County, Dutchess County, Putnam County, Orange County, and Fairfield County
          </h1>

          <p style={styles.compactParagraph}>
            Jet Black Limo specializes in providing luxury transportation services across the region of New York, covering key cities and towns, ensuring comfortable and safe travel.
          </p>

          <p style={styles.compactParagraph}>
            We offer efficient transfers to and from major nearby airports, including JFK, LaGuardia (LGA), Newark (EWR), Westchester County Airport (HPN), Bradley Airport, New York City, and other key locations.
          </p>

          <p style={styles.compactParagraph}>
            Our fleet of luxury vehicles, combined with professional chauffeurs, ensures punctual service for events, corporate meetings, weddings, and long-distance travel.
          </p>
        </section>

        {/* Tarjetas de Servicios */}
        <section style={styles.cardsContainer}>
          {servicesData.map((service, index) => (
            <div
              key={index}
              style={styles.card}
              onMouseEnter={(e) =>
                (e.currentTarget.querySelector('img').style.transform = 'scale(1.05)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.querySelector('img').style.transform = 'scale(1)')
              }
            >
              <div style={styles.imageWrapperCard}>
                <img
                  src={service.image}
                  alt={service.title}
                  style={styles.cardImage}
                  className="cardImage"
                />
              </div>
              <h2 style={styles.cardTitle}>{service.title}</h2>
              {service.subtitle && <h3 style={styles.subtitle}>{service.subtitle}</h3>}
              <p
                style={
                  index === 0
                    ? { ...styles.cardDescription, marginTop: '-10px' }
                    : styles.cardDescription
                }
              >
                {service.description}
              </p>
              <a
                href="http://192.168.2.20:3000/fleet"
                style={styles.cardButton}
                onClick={(e) => {
                  e.preventDefault();
                  // Efecto visual antes de redirigir
                  e.currentTarget.style.border = '2px solid #0d2b3e';
                  setTimeout(() => {
                    window.location.href = 'http://192.168.2.20:3000/fleet';
                  }, 200);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#0d2b3e';
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.querySelector('.arrow').style.marginLeft = '15px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff';
                  e.currentTarget.style.color = '#0d2b3e';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.querySelector('.arrow').style.marginLeft = '8px';
                  e.currentTarget.style.border = 'none';
                }}
              >
                Read More <span className="arrow" style={styles.arrow}>→</span>
              </a>
            </div>
          ))}
        </section>

        <GoogleReviews />

        <div style={styles.midWhiteStripe}></div>
      </main>
    </div>
  );
}

const styles = {
  pageContainer: {
    backgroundColor: '#ffffff',
    color: '#000',
    fontFamily: "'Merriweather', serif",
    margin: 0,
    padding: 0,
    overflowX: 'hidden',
  },
  contentContainer: {
    width: '100%',
    margin: '0 auto',
    padding: '0',
  },
  heroImageSection: {
    width: '100%',
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  heroTextSection: {
    padding: '20px',
    textAlign: 'center',
  },
  subtitle: {
    color: '#000',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    fontFamily: "'Playfair Display', serif",
    marginBottom: '10px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2a2a2a',
    fontWeight: 'bold',
    lineHeight: '1.2',
    marginBottom: '10px',
  },
  boldText: {
    fontWeight: 'bold',
    color: '#000',
  },
  subDescription: {
    fontSize: '1.3rem',
    color: '#495057',
    marginTop: '10px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '40px',
  },
  button: {
    backgroundColor: '#0d2b3e',
    color: '#fff',
    padding: '15px 25px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  icon: {
    fontSize: '1.5rem',
  },
  servicesSection: {
    padding: '40px 20px',
    backgroundColor: '#ffffff',
    maxWidth: '1000px',
    margin: '0 auto',
    textAlign: 'center',
  },
  sectionTitle: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    fontSize: '36px',
    fontWeight: '900',
    fontFamily: "'Playfair Display', serif",
  },
  ourText: {
    color: '#000',
    fontSize: '38px',
    fontWeight: '900',
    textShadow: '3px 3px 8px rgba(0, 0, 0, 0.5)',
  },
  mainHeading: {
    color: '#2F3A4A',
    fontSize: '28px',
    fontWeight: '600',
    fontFamily: "'Playfair Display', serif",
    margin: '10px 0',
  },
  compactParagraph: {
    color: '#6C757D',
    fontSize: '18px',
    lineHeight: '1.6',
    fontFamily: "'Merriweather', serif",
    maxWidth: '1000px',
    margin: '0 auto',
  },
  cardsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '30px',
    padding: '50px 20px',
  },
  card: {
    width: '300px',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    backgroundColor: '#ffffff',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  imageWrapperCard: {
    overflow: 'hidden',
    borderRadius: '8px',
  },
  cardImage: {
    width: '100%',
    borderRadius: '8px',
    transition: 'transform 0.4s ease',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontFamily: "'Playfair Display', serif",
    color: '#2F3A4A',
    margin: '5px 0',
  },
  cardDescription: {
    fontSize: '1rem',
    color: '#6C757D',
    margin: '10px 0',
    fontFamily: "'Merriweather', serif",
  },
  cardButton: {
    backgroundColor: '#ffffff',
    color: '#0d2b3e',
    padding: '15px 40px',
    borderRadius: '10px',
    fontSize: '1rem',
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    border: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
  },
  arrow: {
    fontSize: '1.5rem',
    marginLeft: '8px',
    transition: 'margin-left 0.3s ease',
  },
  midWhiteStripe: {
    width: '100%',
    height: '80px',
    backgroundColor: '#ffffff',
    marginTop: '0px',
    marginBottom: '100px',
  },
};
